import request from '../utils/request.js'
export default {
	getIndexData(params) {
		return request.post(`index/get_index_data`, params).then(res => res.data);
	},
	getIndexChart(params){
		return request.post(`index/get_index_chart`, params).then(res => res.data);
	},
	// 获取套餐信息
	getPackageInfo(params) {
		return request.post(`company_setmeal/info`, params).then(res => res.data);
	},
	// 获取套餐使用情况
	getPackageUsage(params) {
		return request.post(`company_setmeal/usage`, params).then(res => res.data);
	}
}


// WEBPACK FOOTER //
// ./src/api/index.js